document.addEventListener('DOMContentLoaded', () => {
  const viewMoreBtn = document.querySelector('.u-view-more-btn');
  const collectionDesc = document.querySelector('.u-collection-desc');
  let isExpanded = false;
  let initialHeight = 0;

  function getInitialHeight() {
    if (window.innerWidth <= 768) {
      // Mobile: Set height to 40% of viewport height (40vh)
      return Math.round(window.innerHeight * 0.1);
    } else {
      // Desktop: Set height to 30% of viewport height (30vh)
      return Math.round(window.innerHeight * 0.07);
    }
  }

  function setupView() {
    // Calculate initial height based on viewport width
    if (!isExpanded) {
      initialHeight = getInitialHeight();
      collectionDesc.style.height = `${initialHeight}px`;
      collectionDesc.style.overflow = 'hidden';
    }

    viewMoreBtn.style.display = 'block';
    viewMoreBtn.textContent = isExpanded ? '- View Less' : '+ View More';
  }

  function toggleDescription() {
    if (isExpanded) {
      // Collapse
      collectionDesc.style.height = `${initialHeight}px`;
      viewMoreBtn.textContent = '+ View More';
      collectionDesc.classList.remove('expanded');
    } else {
      // Expand
      const fullHeight = Math.round(collectionDesc.scrollHeight);
      collectionDesc.style.height = `${fullHeight}px`;
      viewMoreBtn.textContent = '- View Less';
      collectionDesc.classList.add('expanded');
    }
    isExpanded = !isExpanded;
  }

  // Initial setup
  setupView();

  // Add event listener for toggle
  viewMoreBtn.onclick = toggleDescription;

  // Adjust height on window resize
  window.addEventListener('resize', () => {
    if (!isExpanded) {
      initialHeight = getInitialHeight(); // Recalculate based on new viewport size
      collectionDesc.style.height = `${initialHeight}px`;
    }
  });
});